import { combineReducers } from 'redux'
import settings from './settings'

const tenantUser = combineReducers({
  settings,
})

export default tenantUser
